import React from 'react';
import PropTypes from 'prop-types';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullScreen = false }) => {
  return (
    <div className={`loading-container ${fullScreen ? 'fullscreen' : ''}`}>
      <div className="loading-spinner">
        <div className="spinner-logo" style={{ backgroundImage: 'url(/images/PortRay_ロゴ.png)' }}></div>
        <div className="spinner-bar">
          <div className="spinner-bar-fill"></div>
        </div>
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  fullScreen: PropTypes.bool,
};

export default LoadingSpinner;
